const CHANGE_REASON = 'change_reason';

export {
  CHANGE_REASON,
};
